module.exports = __webpack_public_path__ + "static/osteo-486e01f7c291d05b41cb764bd3c6b38a.png";